<script setup>
const props = defineProps({
  azure: {
    type: Boolean,
    default: false
  },
  showWorkingHours: {
    type: Boolean,
    default: false,
  },
  customContent: {
    type: Boolean,
    default: () => false,
  },
  isInline: {
    type: Boolean,
    default: () => false,
  }
});

const siteConfig = useSiteConfig();
const blend = useBlend();
const nuxtApp = useNuxtApp();
const {onOpenCallPopup} = useCallPopup();

const openPopup = ref(false)
const route = useRoute();
const contactPhone = computed(() => {
  switch (route.name) {
    case 'static-offer-rp':
      return siteConfig.rpContactPhone;
    case 'moya-consumer':
      return siteConfig.moyaContactPhone;
    case 'index':
      return siteConfig.homeContact.phone;
    case 'static-about':
    case 'static-contact':
      return siteConfig.contactPhone;
    case 'static-customer-service':
      return siteConfig.customerServicePhone;
    default:
      return siteConfig.contactPhoneSec;
  }
});

const workingHours = computed(() => {
  if (route.name === 'index') {
    return siteConfig.homeContact.workingHours;
  } else if (route.name === 'static-customer-service') {
    return siteConfig.customerServiceWorkingHours;
  } else {
    return siteConfig.workingHours;
  }
});

const call = () => {
  if (nuxtApp.$isMobile() && isInWorkingHours()) {
    window.location.href = 'tel:' + contactPhone.value;
    return;
  }
  openPopup.value = true
}


blend.blendEffect(openPopup, false, true, true,
  () => {
    openPopup.value = false;
  }
)

onOpenCallPopup(() => openPopup.value = true);
</script>

<template>
  <div :class="{'inline': isInline}" class="cursor-pointer" @click="call">
    <div v-if="!customContent" class="gap-3 items-end hidden lg:flex">
      <div class="text-base text-dark-gray flex items-end gap-1">
        <IconPhone :stroke="azure ? 'rgb(10 102 168)' : ''" />
        <div class="flex flex-col ml-2">
          <div v-if="route.name === 'index'" class="text-xs text-gray-400 font-extralight mt-[-1rem]">Infolinia sprzedażowa</div>
          <div v-else class="text-xs text-gray-400 font-extralight"></div>
          <div class="flex items-center gap-3">
            <div :class="{'text-azure font-normal' : azure}">{{contactPhone}}</div>
            <div v-if="!showWorkingHours" class="text-xs text-gray-400 font-extralight">{{ workingHours.start }} - {{ workingHours.end }}</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{'inline': isInline}"  v-else>
      <slot />
    </div>
    <div v-if="!customContent" class="flex lg:hidden">
      <div class="flex items-center justify-center w-[34px] h-[34px] bg-gray-700 rounded-full">
        <IconPhone stroke="white" size="24" />
      </div>
    </div>
  </div>
  <Teleport to="body">
    <PopupCall :contactPhone="contactPhone" :visible="openPopup" @dismiss="openPopup = false" />
  </Teleport>
</template>
